"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
var pickers_1 = require("@material-ui/pickers");
var EventIcon_1 = __importDefault(require("mdi-react/EventIcon"));
var KeyboardArrowLeftIcon_1 = __importDefault(require("mdi-react/KeyboardArrowLeftIcon"));
var KeyboardArrowRightIcon_1 = __importDefault(require("mdi-react/KeyboardArrowRightIcon"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importDefault(require("react"));
var localization_1 = require("../../utils/localization");
var BeamDatePicker = function (_a) {
    var props = __rest(_a, []);
    var handleOnChange = function (newDate) {
        if (newDate === '') {
            props.onChange(null);
        }
        else {
            props.onChange(newDate);
        }
    };
    var PickerComponent = props.keyboard ? pickers_1.KeyboardDatePicker : pickers_1.DatePicker;
    // keyboard and mask are deprecated, t should not be passed along
    // eslint-disable-next-line no-unused-vars
    var t = props.t, keyboard = props.keyboard, mask = props.mask, passedProps = __rest(props, ["t", "keyboard", "mask"]);
    var keyboardIcon = props.keyboard
        ? {
            keyboardIcon: props.keyboardIcon ? (props.keyboardIcon) : (react_1.default.createElement(EventIcon_1.default, null)),
        }
        : {};
    return (react_1.default.createElement(PickerComponent, __assign({}, keyboardIcon, { leftArrowIcon: props.leftArrowIcon ? (props.leftArrowIcon) : (react_1.default.createElement(KeyboardArrowLeftIcon_1.default, null)), rightArrowIcon: props.rightArrowIcon ? (props.rightArrowIcon) : (react_1.default.createElement(KeyboardArrowRightIcon_1.default, null)), invalidLabel: (0, localization_1.translateProp)(props, 'invalidLabel', 'invalid'), inputVariant: "outlined", variant: "inline", margin: "dense", onChange: handleOnChange, autoOk: true }, passedProps)));
};
exports.DatePicker = BeamDatePicker;
BeamDatePicker.propTypes = {
    props: prop_types_1.default.object,
    keyboard: prop_types_1.default.bool,
    keyboardIcon: prop_types_1.default.node,
    leftArrowIcon: prop_types_1.default.node,
    mask: prop_types_1.default.any,
    rightArrowIcon: prop_types_1.default.node,
    onChange: prop_types_1.default.func,
    t: prop_types_1.default.func,
};
exports.default = BeamDatePicker;
//# sourceMappingURL=index.js.map